import React, { useEffect, useState } from "react";
import { Row, Col, Card, message, Spin } from "antd";
import { getAllcategories } from "../../../utils/API";
import { useNavigate } from "react-router-dom";
import "./Category.css";
import image1 from "../../../assets/frontendassets/png images/categories.png"
import { FaStar } from "react-icons/fa";
const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const imageUrl = `${process.env.REACT_APP_IMAGE_URL}/categories/`;
  const navigate = useNavigate();
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await getAllcategories();
      const formattedOptions = response.filter((category : any) => category.isHome === true && !category.categoryId && !category.isDeleted);
      setCategories(formattedOptions.slice(0, 6)); // Limit to 6 categories
    } catch (error) {
      message.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCategoryClick = (categoryName : any) => {
    navigate(`/listing?category=${categoryName}&state=`);
  };

  return (
    <div className="bg-[#FFF8EC] md:pt-8 xs:p-3 md:ps-8 md:px-8 xl:pt-12 xl:ps-12 xl:px-12 sm:pt-8 sm:ps-8 sm:px-8 ">
      <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} className="p-2 md:p-0">
        <div className="flex items-center pb-3">
          <hr className="w-48 xxs:w-12 xs:w-24 mr-4 " />
        <div className=" text-black text-normal sm:text-sm md:text-md lg:text-[20px] " style={{ letterSpacing: "1.5px",fontFamily: '"Manrope", sans-serif' }}>
            DISCOVER CATEGORIES
          </div>
          </div>
          </Col>
      <Row>
      
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          className="w-full pl-2  md:p-0"
        >
          <div className="text-xl xs:text-3xl md:text-[30px] lg:text-[30px] "style={{ fontFamily: '"Manrope", sans-serif' }}>
            Discover your business more  easily by category
          </div>
        </Col>
        <Col
  xs={24}
  sm={24}
  md={12}
  lg={12}
  xl={12}
  xxl={12}
  className="w-full xs:p-2 xxs:p-2 md:p-4 sm:pt-5 md:p-0"
>
  <div
    className="relative md:absolute bottom-0 text-left md:text-left font-light text-black"
    style={{
      letterSpacing: "1.5px",
      fontFamily: '"Manrope", sans-serif',
    }}
  >
    <p className="text-base sm:text-sm md:text-sm font-[400] lg:text-[18px]">
      We cover all business categories to help you list your businesses and gain visibility.
    </p>
  </div>
</Col>


      </Row>
      <Row className="mt-10  sm:p-8 md:p-8 lg:p-8 bg-[#faf3e7]">
        {loading ? (
          <Spin size="large" />
        ) : (
          categories.map((category : any, index : any) => (
            <Col
            xs={24}
            sm={24}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className={`p-4 category-card cursor-pointer ${
              index >= 3 ? "align-right" : "align-left"
            }`} // Apply dynamic alignment
            key={index}
            onClick={() => handleCategoryClick(category._id)}
          >
            <div className="category-wrapper">
              <div className="category-content relative">
                {/* Stars */}
                <div className="stars-container">
                  <FaStar className="star" />
                  <FaStar className="star" />
                  <FaStar className="star" />
                  <FaStar className="star" />
                  <FaStar className="star" />
                  <FaStar className="star" />
                </div>
          
                {/* Category Image */}
                <img
                  src={imageUrl + category.image}
                  alt={category.name}
                  className="category-image"
                />
          
                {/* Category Label */}
                <div className="category-label">{category.name}</div>
              </div>
            </div>
          </Col>
          
          ))
        )}
      </Row>
    </div>
  );
};

export default Categories;
